<template>
  <div class="player">
    <button class="playBtn" @click="toggle">
      <img :src="`/img/icons/btn-${status ? 'pause' : 'play'}.svg`" alt="" />
    </button>
    <div class="range">
      <input
        ref="range"
        type="range"
        min="0"
        :max="duration"
        :value="0"
        @change="changeCurrentTime"
      />
      <div class="track">
        <div
          class="current"
          :style="{ width: `${(currentTime * 100) / duration}%` }"
        >
          <div class="pointer"></div>
        </div>
      </div>
    </div>
    <div class="counters">{{ time }} / {{ count }}</div>
    <button v-if="load" class="download" @click="download">
      <img src="/img/icons/btn-download.svg" alt="" />
    </button>
  </div>
</template>

<script>
  export default {
    name: 'AudioPlayer',
    props: {
      src: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: false,
        default: ''
      },
      load: {
        type: Boolean,
        default: true
      }
    },

    data() {
      return {
        status: 0,
        player: null,
        duration: 1,
        currentTime: 0
      };
    },

    computed: {
      count: function () {
        const minutes = Math.floor(this.duration / 60);
        const seconds = Math.floor(this.duration % 60);
        return `${minutes < 10 ? "0" : ""}${minutes}:${
          seconds < 10 ? "0" : ""
        }${seconds}`;
      },

      time: function () {
        const minutes = Math.floor(this.currentTime / 60);
        const seconds = Math.floor(this.currentTime % 60);
        return `${minutes < 10 ? "0" : ""}${minutes}:${
          seconds < 10 ? "0" : ""
        }${seconds}`;
      }
    },

    mounted() {
      this.player = new Audio(this.src);

      this.player.addEventListener('loadeddata', () => {
        this.duration = this.player.duration;
        // console.dir(this.player);
      });

      this.player.addEventListener('timeupdate', () => {
        this.currentTime = this.player.currentTime || 0;
      });

      this.player.addEventListener('ended', () => {
        this.status = 0;
      });
    },

    methods: {
      toggle() {
        if (this.player.paused) {
          this.status = 1;
          this.player.play();
        } else {
          this.status = 0;
          this.player.pause();
        }
      },

      changeCurrentTime(e) {
        this.player.currentTime = e.target.value;
        this.currentTime = e.target.value;
      },

      download() {
        const url = this.player.currentSrc;
        const filename = this.title;
        const xhr = new XMLHttpRequest();

        xhr.responseType = 'blob';
        xhr.onload = function() {
          let tagA = document.createElement('a');
          tagA.href = window.URL.createObjectURL(xhr.response);
          tagA.download = filename;
          tagA.style.display = 'none';
          document.body.appendChild(tagA);
          tagA.click();
        };
        xhr.open('GET', url);
        xhr.send();
      }
    }
  };
</script>


<style scoped lang="scss">
  button {
    border: none;
    background: none;
    display: block;
    padding: 0;
    margin: 0 20px 0 0;
    color: #1e90ff;
    font-size: 20px;
    line-height: 1;

    img {
      width: 15px;
    }

    &.download {
      margin-left: 10px;
      width: 18px;
    }
  }
  .player {
    display: flex;
    align-items: center;
  }
  .range {
    width: 300px;
    height: 1px;
    position: relative;
    padding-top: 5px;

    input {
      width: calc(100% + 14px);
      height: 7px;
      margin: 0;
      position: absolute;
      left: -7px;
      top: -3px;
      opacity: 0;
    }
  }
  .track {
    background: #ccc;
    height: 1px;
    position: relative;
    pointer-events: none;
  }
  .current {
    height: 1px;
    position: relative;
    background: #2196f3;
    pointer-events: none;
  }
  .pointer {
    width: 5px;
    height: 5px;
    border-radius: 50%;
    position: absolute;
    top: -2px;
    right: -2.5px;
    background: #2196f3;
    pointer-events: none;
  }
  .counters {
    width: 100%;
    margin-left: 20px;
    color: #777;
    font-size: 13px;
    padding-top: 5px;
  }
</style>
